__turbopack_context__.v({
  "bannerContainer": "GiftTracking-module__P8OOWW__bannerContainer",
  "landscapeContainer": "GiftTracking-module__P8OOWW__landscapeContainer",
  "sharingTruckContainer": "GiftTracking-module__P8OOWW__sharingTruckContainer",
  "showSharingOptions": "GiftTracking-module__P8OOWW__showSharingOptions",
});
